import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "15 14 20 9 15 4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 20v-7a4 4 0 0 1 4-4h12", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "CornerUpRight";
const CornerUpRight = memo(themed(Icon));
export {
  CornerUpRight
};
//# sourceMappingURL=corner-up-right.js.map
